import { Component, Inject, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBar } from '@angular/material/snack-bar';
import { NotificationConfig } from './models/notification-config';
import { TypeMessageEnum } from '../enums/notification-type.enum';
import { DefaultComponentsModule } from 'app/shared/modules/default-components.module';

@Component({
  selector: 'vex-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  standalone: true,
  imports: [DefaultComponentsModule],
})
export class NotificationComponent implements OnInit {

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: NotificationConfig,
    public snackBar: MatSnackBar
  ) { }

  icon: string = '';
  color: string = "";

  ngOnInit(): void {
    this.resolveIcon();
  }

  resolveIcon() {
    switch (this.data.type) {
      case TypeMessageEnum.ERROR:
        this.icon = 'error'
        this.color = "warn"
        break;
      case TypeMessageEnum.INFO:
        this.icon = 'info'
        this.color = "primary"
        break;
      case TypeMessageEnum.SUCCESS:
        this.icon = 'done'
        this.color = "primary"
        break;
      case TypeMessageEnum.WARN:
        this.icon = 'warning'
        this.color = "accent"
        break;
      default:
        this.color = "#000"
        break;
    }
  }


}
